const StatusIndicatorStatus = Object.freeze({
    "online": "online",
    "offline": "offline",
    "busy": "busy"
});
const StatusIndicatorSizes = Object.freeze({
    "big": "big",
    "default": "default",
    "medium": "medium",
    "small": "small",
    "extra-small": "extra-small",
    "extra-small-1": "extra-small-1"
});
var StatusIndicatorProps = { StatusIndicatorStatus, StatusIndicatorSizes };

export { StatusIndicatorProps as default };
//# sourceMappingURL=status_indicator.js.map
